import { GlobalStyles } from "@mui/material"

// A separate family name keeps the real weights inside the nav; declaring more weights
// for "Urbanist" itself would change type rendering across the whole app
const NAV_FONT_NAME = "Urbanist Nav"
const URBANIST_FILES = "https://fonts.gstatic.com/s/urbanist/v18"

export const NAV_FONT_FAMILY = `"${NAV_FONT_NAME}", Urbanist, sans-serif`

export const navFontSx = { "&&, && *": { fontFamily: NAV_FONT_FAMILY } }

export const navTooltipSlotProps = { tooltip: { sx: navFontSx } }

const FONT_FACES = [
    {
        file: "L0x-DF02iFML4hGCyMqlbS1miXK2.woff2",
        unicodeRange:
            "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD",
    },
    {
        file: "L0x-DF02iFML4hGCyMqrbS1miXK2Z7s.woff2",
        unicodeRange:
            "U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C4, U+2113, U+2C60-2C7F, U+A720-A7FF",
    },
]

export function NavFontFace() {
    return <GlobalStyles styles={FONT_FACES.map(toFontFace)} />
}

function toFontFace({ file, unicodeRange }) {
    return {
        "@font-face": {
            fontFamily: NAV_FONT_NAME,
            fontStyle: "normal",
            fontWeight: "400 700",
            fontDisplay: "swap",
            src: `url(${URBANIST_FILES}/${file}) format("woff2")`,
            unicodeRange,
        },
    }
}
